// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6829efa6","890":"0a3e7e1e","921":"d3c5a7c6"}[chunkId] + ".chunk.js";
};